import dayjs from 'dayjs';
import { NonResourcePricingTable, RevenueData } from '../interfaces/interfaces';

export const getNonResourceRevenue = (rows: NonResourcePricingTable[], months: string[], offset: number): RevenueData[] =>
  rows.filter(row => row.selectRegion && row.serviceLineCapability && row.function && row.monthlyCost > 0)
    .map((row, index) => {
      const values: Record<string, number> = {
        'Billable Hours': 0,
        'Revenue $': Math.round(row.targetPricePerMonth),
        'Target Revenue $': Math.round(row.targetPricePerMonth),
        'Cost $': Math.round(row.monthlyCost),
        'Client Margin $': Math.round(row.targetPricePerMonth) - Math.round(row.monthlyCost),
        'Target Margin $': Math.round(row.targetPricePerMonth) - Math.round(row.monthlyCost),
      };
      const children = Object.entries(values).map(([role, value], childIndex) => {
        const child: any = { key: `${offset + index + 1}-${childIndex + 1}`, role, total: 0 };
        months.forEach((month, monthIndex) => {
          const [name, year] = month.split('-');
          const date = dayjs(new Date(2000 + Number(year), ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'].indexOf(name), 1));
          child[`month${monthIndex}`] = date.isBefore(row.startDate.startOf('month')) || date.isAfter(row.endDate.startOf('month')) ? 0 : value;
          child.total += child[`month${monthIndex}`];
        });
        return child;
      });
      const revenue = children[1];
      const monthlyValues = Object.fromEntries(Object.entries(revenue).filter(([key]) => key.startsWith('month')));
      return {
        key: `month${offset + index + 1}`,
        role: `Non-Resource - ${row.selectRegion} - ${row.serviceLineCapability} - ${row.function}`,
        total: revenue.total, children, ...monthlyValues,
      };
    });
